import React, { useEffect, useRef, useState } from "react";
import "./EditarPerfilTrilhoModal.css";

const normalizePerfilNumero = (value, max = 3) => String(value ?? "").replace(/\D/g, "").slice(0, max);

export default function EditarPerfilTrilhoModal({ open, onClose, onSalvar, numeroInicial = "" }) {
  const [numero, setNumero] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const numeroRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setNumero(normalizePerfilNumero(numeroInicial));
    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => numeroRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, numeroInicial]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const normalized = normalizePerfilNumero(numero);
      if (!normalized) throw new Error("Informe o numero do perfil.");
      await onSalvar?.(normalized);
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alteracoes.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ptemd-overlay" onClick={onClose}>
      <div className="ptemd-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar perfil de trilho">
        <div className="ptemd-head">
          <h3 className="ptemd-title">Editar Perfil de Trilho</h3>
          <button className="ptemd-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ptemd-body">
          <label className="ptemd-field">
            <span>Perfil de trilho</span>
            <div className="ptemd-prefixed">
              <span className="ptemd-prefix">TR</span>
              <input
                ref={numeroRef}
                type="text"
                inputMode="numeric"
                value={numero}
                onChange={(event) => setNumero(normalizePerfilNumero(event.target.value))}
                placeholder="Ex: 57"
                autoComplete="off"
              />
            </div>
          </label>
          {err ? <div className="ptemd-error">{err}</div> : null}
        </div>

        <div className="ptemd-foot">
          <button className="ptemd-btn ptemd-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ptemd-btn ptemd-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alteracoes"}
          </button>
        </div>
      </div>
    </div>
  );
}

